import React from "react";
import { NumericFormat } from "react-number-format";
import { Box, Button, TextField } from "@mui/material";

const MyInputNum = ({
  disabled = false,
  selectedValue,
  handleChangeValue,
  handleAdd,
}) => {
  const handleClick = (event) => {
    event.stopPropagation(); // Prevent bubbling to parent
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1}
      width="100%"
      onClick={handleClick}
    >
      <Box flex={2}>
        <NumericFormat
          thousandSeparator=" "
          decimalScale={2}
          decimalSeparator=","
          allowedDecimalSeparators={[",", "."]}
          customInput={TextField}
          fullWidth
          size="small"
          id="outlined-basic"
          variant="outlined"
          placeholder="0.00"
          value={selectedValue}
          onChange={handleChangeValue}
          disabled={disabled}
        />
      </Box>
      <Box flex={1}>
        <Button
          variant="contained"
          color="success"
          fullWidth
          sx={{ height: "100%" }}
          onClick={handleAdd}
          disabled={disabled}
        >
          +
        </Button>
      </Box>
    </Box>
  );
};

export default MyInputNum;
